<template>
  <v-card
    class="ma-0"
    flat
    style="padding: 0px 15px; border-bottom: 1px solid #ddd;"
    width="100%"
    @click="onClick"
  >
    <!--    :color="{'red': item.isReservationIsOver }"-->
    <v-list-item
      class="pa-0"
      two-line
    >
      <v-list-item-content class="pa-0">
        <v-list-item-title class="text-left">
          {{ item.raw.codeValue }}
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>
  </v-card>
</template>

<script>
    export default {
        name: "CodeItemSimpleCard",
        components: {},
        props: {
            item: {type: Object, default: undefined},
        },
        computed: {
        },
        methods: {
          onClick() {
              this.$emit('pick', this.item.raw);
          },
        }
    }
</script>

<style scoped>
    .v-application .subtitle-2 {
        font-size: 0.875rem;
        font-weight: inherit !important;
        letter-spacing: 0.0071428571em !important;
        line-height: 1.375rem;
        font-family: "Roboto", sans-serif !important;
    }
</style>